exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.success[data-v-88317e50] {\n    text-align: center;\n}\n.success-sub[data-v-88317e50] {\n    text-align: center;\n    text-transform: none;\n    letter-spacing: normal;\n    font-size: 18px;\n    max-width: 280px;\n    line-height: 1.4;\n    margin: 0 auto 40px;\n}\n", ""]);

// exports
